import React, {useState, useEffect} from 'react';

import {useDispatch} from 'react-redux';

import * as setupActions from '@/actions/setupActions';
import {Post} from '@/api/request';
import PcLogo from '@/assets/images/LogoPC.png';
import Button from '@/components/button/Button';
import CheckBox from '@/components/checkBox/CheckBox';
import * as APPDATA from '@/constants/pcConstAppData';
import {consoleLog, consoleError} from '@/libs/consoleHelper';
import {newLineHtml} from '@/libs/htmlHelper';

import './RemoteSupportPage.less';

function RemoteSupportPage() {
  const dispatch = useDispatch();
  const [isRestart, setIsRestart] = useState(false);
  useEffect(() => {
    dispatch(setupActions.updateActiveMenu(APPDATA.ERROR_PAGE));
    return () => {};
  }, []); // notice the empty array
  const sucessPostRestart = () => {
    consoleLog('sucessPostRestart');
  };
  const onClick = (e) => {
    const button = e.currentTarget.id;
    consoleLog(`${button} clicked`);
    postStopRemoteSupport();
  };
  const postStopRemoteSupport = () => {
    const param = {};
    const passingVariabel = {};
    Post(
      APPDATA.API.API_REMOTE_SUPPORT.POST_STOP_REMOTE_SUPPORT,
      param,
      successPostStopRemoteSupport,
      passingVariabel,
      errorPostStopRemoteSupport,
    );
  };
  const successPostStopRemoteSupport = (response, passingVariabel) => {
    consoleLog('successPostStopRemoteSupport', {response, passingVariabel});
    if (isRestart) {
      if (APPDATA.CONFIGURATION.IS_DEVELOPMENT_MODE) {
        window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
      } else {
        const param = {};
        const passingValue = {};
        Post(APPDATA.API.PCServiceAPI.Device.REBOOT, param, sucessPostRestart, passingValue);
        // Post(APPDATA.API.POST_RESTART, param, this.sucessPostRestart, passingValue);
      }
    } else {
      window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
    }
  };
  const errorPostStopRemoteSupport = (error, passingVariabel) => {
    consoleError('errorPostStopRemoteSupport', {error, passingVariabel});
  };
  const toggleCheckboxValue = (e) => {
    const {checked} = e.currentTarget;
    consoleLog('Checkbox Clicked', checked);
    setIsRestart(checked);
  };
  return (
    <div className="remoteSupportPage">
      <div className="rowLogo">
        <img
          alt={PcLogo}
          src={PcLogo}
          className="logo"
        />
      </div>

      <div className="rowLogoName">
        <span className="logoName">
          {APPDATA.PRODUCT_NAME.replace('®', '')} TFF <sup style={{display: 'none'}}>®</sup>
        </span>
      </div>
      <div className="rowTitle">
        <span className="title">{APPDATA.MESSAGES.REMOTE_SUPPORT.PAGE.TITLE}</span>
      </div>
      <div className="rowText">
        <span className="text">{newLineHtml(APPDATA.MESSAGES.REMOTE_SUPPORT.PAGE.TEXT)}</span>
      </div>
      <div className="rowCheckBox">
        <CheckBox
          id="isRestart_checkbox"
          onChange={toggleCheckboxValue}
          value={isRestart}
          defaultChecked={isRestart}
          text={APPDATA.MESSAGES.REMOTE_SUPPORT.PAGE.CHECKBOX} // v
        />
      </div>

      <div className="rowButton">
        <Button
          id={APPDATA.MESSAGES.REMOTE_SUPPORT.PAGE.BUTTON}
          onClick={onClick}
          className="button center"
          label={APPDATA.MESSAGES.REMOTE_SUPPORT.PAGE.BUTTON.toUpperCase()}
        />
      </div>
    </div>
  );
}

export default RemoteSupportPage;
